import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import UserService from '../../core/service/UserService';
import COMPANY_LOGO from "../../../src/images/logo.png";

const UserVerification = ({ t }) => {
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key') ?? null;
  const emailId = searchParams.get('email') ?? null;

  const [verificationInProgress, setVerificationInProgress] = useState(true);
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    console.log(key);
    console.log(emailId);
    if (key != null) {
      UserService.activateUser(key).then(res => {
        if (res.status === 200) {          
          setVerified(true);
        } else {
          setVerified(false);
        }
        setVerificationInProgress(false);
      }).catch(_ => {
        setVerified(false);
        setVerificationInProgress(false);
      });
    }
  }, []);

  return (
    <section className="Set_Pwd_page_section">
      <div className="row m-0">
        <div className="col-lg-6 col-md-6 p-0 Set_Pwd_leftBox">
          <div className="Set_Pwd_leftBox_Logo">
            <img src={COMPANY_LOGO} />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 p-0 Set_Pwd_RightBox">
          <div className="Set_Pwd_Form">   
            {
              !verificationInProgress && verified &&
              <div className="mb-4 Set_Pwd_Form_in_head">
                <h4>{t("UserVerificationSuccess.message1")}</h4>
                <h4>{t("UserVerificationSuccess.message2")} {emailId}</h4>
              </div>
            }
            {
             !verificationInProgress && !verified &&
             <h4>{t("UserVerificationFailure.message")}</h4>
            }
          </div>
        </div>
      </div>
    </section>
  )
};

export default withTranslation()(UserVerification);
